import React from 'react';

// nodejs library to set properties for components
import PropTypes from 'prop-types';

// nodejs library that concatenates classes
import classNames from 'classnames';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';

// core components
// import styles from '../../assets/jss/material-kit-react/components/customInputStyle';
import CoreInput from '../CoreInput/CoreInput';

const styles = {
  disable: {},
};

export default function CustomsSelect(props) {
  const classes = makeStyles(styles);

  const { formControlProps, labelText, options, value, onChange } = props;

  var formControlClasses;
  if (formControlProps !== undefined) {
    formControlClasses = classNames(formControlProps.className, classes.formControl);
  } else {
    formControlClasses = classes.formControl;
  }

  return (
    <FormControl {...formControlProps} className={formControlClasses}>
      <InputLabel shrink htmlFor="bootstrap-input">
        {labelText}
      </InputLabel>
      <Select
        fullWidth
        value={value}
        onChange={onChange}
        variant="outlined"
        // className={classes.textField}
        SelectDisplayProps={{
          style: {
            height: '1.1875em',
          },
        }}
        input={<CoreInput />}
      >
        <MenuItem value="">
          <em>Vacío</em>
        </MenuItem>
        {options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

CustomsSelect.defaultProps = {
  value: '',
  options: [],
};

CustomsSelect.propTypes = {
  labelText: PropTypes.string,
  // labelProps: PropTypes.object,
  // id: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // inputProps: PropTypes.object,
  // formControlProps: PropTypes.object,
  // inputRootCustomClasses: PropTypes.string,
  // error: PropTypes.bool,
  // success: PropTypes.bool,
  // white: PropTypes.bool,
  // fullWidth: PropTypes.bool,
  options: PropTypes.array,
};
